<template>
  <div class="p-the-c01-form-note-panel-gift-card">
    <div class="p-the-c01-form-note-panel-gift-card__content">
      カートに商品が入っておりますので、先にご精算をお願いいたします。<br />※現在、1種類ごとにお申込み、ご精算をお願いしております<br />※個数の変更が出来ない商品は、1枚ごとのお申し込み商品となります。
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class TheC01ItemFormOnlyTypeInCart extends Vue {}
</script>

<style lang="scss" scoped>
.p-the-c01-form-note-panel-gift-card {
  &__content {
    @include text__body--s;
    padding: rem(16);
    display: flex;
    letter-spacing: 0;
    border: px(1) solid $error;
    color: $error;
    width: 100%;
    line-height: rem(16);
    max-width: rem(440);
  }
}
</style>
